import { ButtonHTMLAttributes, forwardRef, InputHTMLAttributes } from "react";
import UpdateCheckIcon from "../../../assets/icons/UpdateCheckIcon";

type PriceInputProps = {
  buttonProps: ButtonHTMLAttributes<HTMLButtonElement>;
} & InputHTMLAttributes<HTMLInputElement>;

// Price update input component
const PriceInput = forwardRef<HTMLInputElement, PriceInputProps>(
  ({ buttonProps, ...rest }, ref) => (
    <div className="relative w-24">
      <input
        ref={ref}
        type="number"
        className="text-body text-sm font-roboto leading-normal py-1 px-1.5 border border-solid border-others-border rounded !pr-7 focus-within:!outline-others-border hide_number_arrow w-full"
        min={0}
        {...rest}
      />

      <button
        className="p-0 m-0 border-transparent bg-transparent cursor-pointer text-primary absolute right-1.5 top-2/4 -translate-y-2/4 flex justify-center items-center"
        {...buttonProps}
      >
        <UpdateCheckIcon />
      </button>
    </div>
  )
);
PriceInput.displayName = "PriceInput";

export default PriceInput;
